/* global axios */

import ApiClient from '../ApiClient';

class N8nCredentials extends ApiClient {
  constructor() {
    super('n8n_credentials', { accountScoped: true });
  }

  // Get all credential types grouped by category
  getTypes() {
    return axios.get(`${this.url}/types`);
  }

  // Get schema for a specific credential type
  getSchema(type) {
    return axios.get(`${this.url}/schema`, { params: { type } });
  }

  // Test a credential connection
  test(credentialId) {
    return axios.post(`${this.url}/${credentialId}/test`);
  }

  // Create credential with name, type and data
  create(payload) {
    return axios.post(this.url, payload);
  }

  // Update credential data
  update(credentialId, payload) {
    return axios.patch(`${this.url}/${credentialId}`, payload);
  }
}

export default new N8nCredentials();
